import addItemToArray from 'forms-utils-lib/utils/array/addItemToArray';
import { updatePrivateInternalIdsOnFieldGroups } from 'FormsUI/utils/FormFieldsUtils';
import { getIsSinglePaymentLink } from 'FormsUI/utils/PaymentsUtils';
const getNewFormFieldGroupIndex = ({
  index,
  hasSinglePaymentLink
}) => {
  // single payment fields should be hidden on the editor
  // they are added on the last position
  // allowing the other fields to be dragged without issues
  if (hasSinglePaymentLink) {
    return index - 1;
  } else {
    return index;
  }
};
export const addFormFieldGroup = (formFieldGroups, formFieldGroupIndex, newFormFieldGroup, {
  paymentLinkFormField
}) => {
  const hasSinglePaymentLink = Boolean(paymentLinkFormField && getIsSinglePaymentLink(paymentLinkFormField));
  const index = getNewFormFieldGroupIndex({
    index: formFieldGroupIndex,
    hasSinglePaymentLink
  });
  return updatePrivateInternalIdsOnFieldGroups(addItemToArray(formFieldGroups, index, newFormFieldGroup));
};
export default addFormFieldGroup;